import { useTranslation } from "hhn-commons";
import { InputField } from "./InputFields.style";

type InputGroupAboutProps = {
  value: string | undefined;
  onAboutChange: (key: string, value: string) => void;
};

const InputGroupAbout = ({ value, onAboutChange }: InputGroupAboutProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "internalGroup" });

  return (
    <InputField
      fullWidth
      id="outlined-multiline-static"
      label={tNs("aboutLabel")}
      multiline
      rows={4}
      value={value || ""}
      onChange={event => onAboutChange("about", event.target.value)}
      slotProps={{
        formHelperText: {
          ...({ "data-testid": "about-input-length" } as any),
          sx: {
            textAlign: "right",
            marginRight: 0,
            fontSize: 11,
          },
        },
        htmlInput: {
          "data-testid": "about",
          maxLength: 3000,
        },
      }}
      helperText={`${value?.length || 0} / 3000`}
    />
  );
};

export default InputGroupAbout;
